// extracted by mini-css-extract-plugin
export default {"content":"ReferralProgramSpaceTooltip__content--2tT5L"};